import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { action } from 'satcheljs/lib/legacy';
import { calculateRequestRange } from 'owa-calendar-surface';
import { DateRange } from 'owa-datetime-utils';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getItemsForAllFolders } from 'owa-calendar-surface-events-lock-store';
import { addCalendarItems } from 'owa-calendar-surface-dategrid';
import { isEventInVisualDateRange } from 'owa-calendar-events-visual-date-range';

/**
 * Loads items when the date range or date range type changes and updates the calendar
 * surface items list accordingly
 * @param dateRange: The date range
 * @param dateRangeType: The date range type
 */
let loadItemsOnDateRangeChange = action('loadItemsOnDateRangeChange')(
    function loadItemsOnDateRangeChange(
        dateRange: DateRange,
        dateRangeType: DateRangeType
    ): Promise<void[]> {
        let requestRange = calculateRequestRange(
            surfaceStore.selectedDate,
            dateRange,
            dateRangeType,
            surfaceStore.userOptions.weekStartDay
        );

        const folderPromises = getItemsForAllFolders(requestRange).map(promise => {
            return promise.then(items => {
                if (items !== null) {
                    items = items.filter(isEventInVisualDateRange(requestRange));
                }
                addCalendarItems(items, surfaceStore, false);
            });
        });

        return Promise.all(folderPromises);
    }
);

export default loadItemsOnDateRangeChange;
